export const API_URL_EXTERNAL = import.meta.env.VITE_API_URL_EXTERNAL;
